import { Injectable, Inject } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { APP_INSIGHTS_CONFIG } from '../environments/environments.module';

@Injectable({
  providedIn: 'root',
})
export class ApplicationInsightService {
  private appInsights: ApplicationInsights;
  APP_INSIGHTS_CONFIG: any;

  constructor(@Inject(APP_INSIGHTS_CONFIG) APP_INSIGHTS_CONFIG: any) {
    this.APP_INSIGHTS_CONFIG = APP_INSIGHTS_CONFIG;
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: this.APP_INSIGHTS_CONFIG.instrumentationKey,
        enableAutoRouteTracking:
          this.APP_INSIGHTS_CONFIG.enableAutoRouteTracking,
      },
    });
    this.appInsights.loadAppInsights();
  }

  setUserId(userId: string) {
    this.appInsights.setAuthenticatedUserContext(userId);
  }

  clearUserId() {
    this.appInsights.clearAuthenticatedUserContext();
  }

  logPageView(name?: string, url?: string) {
    // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url,
    });
  }

  logEvent(name: string, properties?: Record<string, any>) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: Record<string, any>) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({
      exception: exception,
      severityLevel: severityLevel,
    });
  }

  logTrace(message: string, properties?: Record<string, any>) {
    this.appInsights.trackTrace({ message: message }, properties);
  }
}
